import React, { Component } from 'react'
import { TRANSLATIONS_QUERY, UPDATE_TRANSLATIONS_QUERY, DELETE_TRANSLATIONS_QUERY } from "../../queries/Queries"
import { IconButton } from '@mui/material';
import { FaLockOpen, FaLock, FaSortUp, FaSortDown } from "react-icons/fa";
import { useMutation, useQuery } from '@apollo/react-hooks';
import CircularProgressIndicator from '../elements/CircularProgressIndicator';
import { FaSave, FaTrash } from "react-icons/fa";
// import Skill from './Skill';
import SavedTranslation from './SavedTranslation';
import { AUTH_TOKEN } from '../../constants';
import { flattenStrapiData } from '../../utils/utilities';

class SavedTranslationList extends Component {
  state = {
    locked: true,
    error: "",
    columns: [
        {column: "id",              direction: "asc"},
        {column: "language",        direction: "asc", filter: ""},
        {column: "identification",  direction: "asc", filter: ""},
        {column: "translation",                       filter: ""},
        {column: "createdAt",      direction: "asc"},
        {column: "updatedAt",      direction: "asc"},
    ],
    sortBy: "id:asc",
    filters: {identification: {containsi: ""} }
  }

  onChangeFilter(e, index) {
      let columns = this.state.columns;
      for(let i = 0; i < columns.length; i++) {
          if(columns[i].filter !== undefined)
            columns[i].filter = ""
      }
      columns[index].filter = e.target.value
      // console.log("filter: " + columns[index].filter)
      this.setState({columns: columns,})
  }
  
  onSubmitFilter(e, index) {
    e.preventDefault();
    let columns = this.state.columns;
    // console.log("columns " + columns[index].column + " filter: "+ columns[index].filter) 
    // columns[index].filter = e.target.value
    let filters = { 
      [columns[index].column]: {containsi: columns[index].filter}
    }
    // console.log("on submit filters:" + filters)
    this.setState({filters: filters,})
  }

  handleLockChange(e) {
    this.setState({locked: !this.state.locked});
  }

  updateColumn(at) {
    let column = this.state.columns[at]
    if(column.direction === undefined)
        return;

    column.direction = column.direction === 'asc' ? 'desc' : 'asc';
    let columns = this.state.columns;
    for(let i = 0; i < columns.length; i++) {
        if(columns[i].direction === undefined)
            continue;
        if(i === at)
            columns[at] = column
        else
            columns[i].direction = 'asc'
    }
    let sortBy =  column.column + ":" + column.direction
    this.setState({columns: columns, sortBy: sortBy})
  }

  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    if(!token) {
      return(
        <div>
          <span className="Error">You must be loged in first</span>
        </div>
      )
    }

    return (
        <div>
          <IconButton onClick={this.handleLockChange.bind(this)} >{this.state.locked ? <FaLock/> : <FaLockOpen/> }</IconButton>
          <br/>
          <div><span className="error">{this.state.error}</span></div>
          <GetList
            token={token} 
            locked={this.state.locked}
            updateColumn={this.updateColumn.bind(this)}
            onChangeFilter={this.onChangeFilter.bind(this)}
            onSubmitFilter={this.onSubmitFilter.bind(this)}
            columns={this.state.columns}
            sortBy={this.state.sortBy}
            filters={this.state.filters}
          />
      </div>
    )
  }
}

function GetList({locked, token, updateColumn, onChangeFilter, onSubmitFilter, columns, sortBy, filters}) {
  console.log(`sortBy: ${sortBy}, filters: ${JSON.stringify(filters)}`)
  const {data, loading, error, refetch} = useQuery(TRANSLATIONS_QUERY, {variables: {sortBy: sortBy, filters: filters}})
  
  if(error) return(<span className="error">{error.message}</span>)
  
  function sort(columnNumber) {
    updateColumn(columnNumber)
    refetch({variables: {sortBy: sortBy, filters: filters}})
  }

  function getArrow(direction) {
    return direction === "asc" ? <FaSortUp/> : <FaSortDown/>
  }
 
  function filter(e, index) {
    onChangeFilter(e, index)
  }

  function getColumnHeader(index) {
    return <th >
      <div>
        <h4>{columns[index].column}</h4>
        {columns[index].filter !== undefined ? 
        <form onSubmit={(e) => onSubmitFilter(e, index)}><input  value={columns[index].filter}  onChange={(e) => filter(e, index)} /></form>
        : ""} 
       <div onClick={columns[index].direction !== undefined ? () => sort(index) : () => {}}>{columns[index].direction !== undefined ? getArrow(columns[index].direction) : ""}</div>
      </div>
    </th>;
  }

  let translations = data?.savedTranslations?.data
  return (
    <div>{
      loading ? <CircularProgressIndicator size={60} /> : <table className="table table-bordered">
        <thead>
          <tr>
            {getColumnHeader(0)}
            {getColumnHeader(1)}
            {getColumnHeader(2)}
            {getColumnHeader(3)}
            {getColumnHeader(4)}
            {getColumnHeader(5)}
            {token && !locked && <th><h4>Edit</h4></th>}
            {token && !locked && <th><h4>Delete</h4></th>}
          </tr>
        </thead>
          
          <tbody>
          {translations !== undefined ? translations.map(translation => {
            translation = flattenStrapiData(translation)
            return <SavedTranslation 
            key={translation.id} 
            locked={locked} 
            translation={translation}>
              <Delete refetch={() => refetch()}/>
              <Update refetch={() => refetch()}/>
            </SavedTranslation>
          }) : "a"}
        </tbody>
      </table> }
    </div>
  )
}

function Delete({id, refetch}) {
  const [deleteTranslation, {loading, error}] = useMutation(DELETE_TRANSLATIONS_QUERY)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) alert("Delete Mutation Error: "+ error.message)
  return (
      <IconButton onClick={e => deleteTranslation({variables: {id: id}})
      .then(data => refetch())
      .catch(e => alert("Execute Update Mutation Error: "+e))}><FaTrash/></IconButton>
  )
}

function Update({id, state, refetch}) {
  const [upadateTranslation, {loading, error}] = useMutation(UPDATE_TRANSLATIONS_QUERY)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) {
  console.log("ERROR:"+error)
  alert("Update Mutation Error: "+ error.message)
}
  return (
      <IconButton onClick={e => { 
      upadateTranslation({variables: {id: id, translation: state.translation}})
      .then(data => refetch())
      .catch(e => alert("Execute Update Mutation Error: "+e))
    }
    }><FaSave/></IconButton>
  )
}


export default SavedTranslationList